"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmojiPicker = EmojiPicker;
var _react = _interopRequireDefault(require("react"));
var _cn = require("@udecode/cn");
var _plateEmoji = require("@udecode/plate-emoji");
var _emojiPickerContent = require("./emoji-picker-content");
var _emojiPickerNavigation = require("./emoji-picker-navigation");
var _emojiPickerPreview = require("./emoji-picker-preview");
var _emojiPickerSearchAndClear = require("./emoji-picker-search-and-clear");
var _emojiPickerSearchBar = require("./emoji-picker-search-bar");
var _jsxRuntime = require("react/jsx-runtime");
function EmojiPicker(_ref) {
  var clearSearch = _ref.clearSearch,
    emoji = _ref.emoji,
    emojiLibrary = _ref.emojiLibrary,
    focusedCategory = _ref.focusedCategory,
    handleCategoryClick = _ref.handleCategoryClick,
    hasFound = _ref.hasFound,
    i18n = _ref.i18n,
    icons = _ref.icons,
    isSearching = _ref.isSearching,
    onMouseOver = _ref.onMouseOver,
    onSelectEmoji = _ref.onSelectEmoji,
    refs = _ref.refs,
    searchResult = _ref.searchResult,
    searchValue = _ref.searchValue,
    setSearch = _ref.setSearch,
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? _plateEmoji.EmojiSettings : _ref$settings,
    visibleCategories = _ref.visibleCategories;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: 'plate-editor-wrapper',
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _cn.cn)('flex flex-col rounded-xl bg-card', 'h-[23rem] w-80 border shadow-md'),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_emojiPickerNavigation.EmojiPickerNavigation, {
        emojiLibrary: emojiLibrary,
        focusedCategory: focusedCategory,
        i18n: i18n,
        icons: icons,
        onClick: handleCategoryClick
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_emojiPickerSearchBar.EmojiPickerSearchBar, {
        i18n: i18n,
        searchValue: searchValue,
        setSearch: setSearch,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_emojiPickerSearchAndClear.EmojiPickerSearchAndClear, {
          clearSearch: clearSearch,
          i18n: i18n,
          searchValue: searchValue
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_emojiPickerContent.EmojiPickerContent, {
        emojiLibrary: emojiLibrary,
        i18n: i18n,
        isSearching: isSearching,
        onMouseOver: onMouseOver,
        onSelectEmoji: onSelectEmoji,
        refs: refs,
        searchResult: searchResult,
        settings: settings,
        visibleCategories: visibleCategories
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_emojiPickerPreview.EmojiPickerPreview, {
        emoji: emoji,
        hasFound: hasFound,
        i18n: i18n,
        isSearching: isSearching
      })]
    })
  });
}